import { DataModel } from './data-model.model';
import { Category } from './category.model';

export class ModuleCategoryV1Read extends DataModel implements Category {
    id: string;
    name: string;
    numberOfPublicModules: number;

    numberOfItems(): number {
        return this.numberOfPublicModules;
    }
}
